const getAlertsData = (state) => state.commonState.AlertsState.data;

export default {
  getAlertsData,
};
